module.exports = ".main-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 25vw;\n  height: 20vh;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n  .main-container .error-msg {\n    color: #868686;\n    font-size: 18px;\n    font-weight: 500; }\n\n.link {\n  color: #00a9ff;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forgot-password/error-dialog/error-dialog.component.scss
// module id = 171
// module chunks = 1